import EnumEstado from '../../../types/enum/Estado';
import TipoAcesso from '../../../types/TipoAcesso';
import { IDocumentoConta, ITipoLiquidacao } from '../user/reducer';

export enum EnumAuthActions {
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  UPDATE_RESPONSABILIDADE = 'UPDATE_RESPONSABILIDADE',
  UPDATE_SHOW_CURRENCY_VALUE = 'UPDATE_SHOW_CURRENCY_VALUE',
  TOGGLE_MENU = 'TOGGLE_MENU',
}

export enum EnumAuthContext {
  BACKOFFICE = "backoffice",
  PANEL = "panel",
  SISTEMA = "sistema",
  TERMINAL = "terminal",
}

export enum EnumResponsibility {
  INDICADOR = 1,
  REPRESENTANTE = 2,
  ESTABELECIMENTO = 3,
  RESPONSAVEL = 4,
  INCENTIVADOR = 5,
  SERVIDOR_PUBLICO_ADMINISTRADOR = 6,
  SERVIDOR_PUBLICO = 7,
  ESTABELECIMENTO_DETRAN = 8,
}

export enum EnumProfileNameCorrelationPermissions {
  RECURRENCE = "RECURRENCE",
  REPORT = "REPORT",
  TRANSACTION = "TRANSACTION",
  BACKOFFICE_FEE = "BACKOFFICE_FEE",
  ESTABLISHMENT = "ESTABLISHMENT",
  CHECKOUT = "CHECKOUT",
  PAYMENT_LINK = "PAYMENT_LINK",
  PAYMENT_LINK_LIST = "PAYMENT_LINK_LIST",
  PAYMENT_LINK_DETAIL = "PAYMENT_LINK_DETAIL",
  ESTABLISHMENT_LIST = "ESTABLISHMENT_LIST",
  ESTABLISHMENT_DETAIL = "ESTABLISHMENT_DETAIL",
  ESTABLISHMENT_CREATE = "ESTABLISHMENT_CREATE",
  ESTABLISHMENT_UPDATE = "ESTABLISHMENT_UPDATE",
  TRANSACTION_LIST = "TRANSACTION_LIST",
  TRANSACTION_DETAIL = "TRANSACTION_DETAIL",
  FEE_LIST_PLAN = "FEE_LIST_PLAN",
  FEE_DETAIL_PLAN = "FEE_DETAIL_PLAN",
  FEE_CREATE_PLAN = "FEE_CREATE_PLAN",
  FEE_DEACTIVATE_PLAN = "FEE_DEACTIVATE_PLAN",
  FEE_REMOVE_PLAN = "FEE_REMOVE_PLAN",
  FEE_CREATE = "FEE_CREATE",
  FEE_EDIT = "FEE_EDIT",
  FEE_REMOVE = "FEE_REMOVE",
  REPORT_TRANSACTION_VIEW = "REPORT_TRANSACTION_VIEW",
  RECURRENCE_SUBSCRIPTION_LIST = "RECURRENCE_SUBSCRIPTION_LIST",
  RECURRENCE_SUBSCRIPTION_DETAIL = "RECURRENCE_SUBSCRIPTION_DETAIL",
  RECURRENCE_PLAN_LIST = "RECURRENCE_PLAN_LIST",
  RECURRENCE_PLAN_DETAIL = "RECURRENCE_PLAN_DETAIL",
  RECURRENCE_INVOICE_DETAIL = "RECURRENCE_INVOICE_DETAIL",
  CHECKOUT_LIST = "CHECKOUT_LIST",
  CHECKOUT_DETAIL = "CHECKOUT_DETAIL",
  REPORT_RECURRENCE_VIEW = "REPORT_RECURRENCE_VIEW",
  LIQUIDATION_CREATE = "LIQUIDATION_CREATE",
  LIQUIDATION_DETAIL = "LIQUIDATION_DETAIL",
  LIQUIDATION_LIST = "LIQUIDATION_LIST",
  LIQUIDATION_UPLOAD = "LIQUIDATION_UPLOAD",
  LIQUIDATION_DOWNLOAD = "LIQUIDATION_DOWNLOAD",
  PARAMETERIZATION_MCC_LIST = "PARAMETERIZATION_MCC_LIST",
  PARAMETERIZATION_MCC_CREATE = "PARAMETERIZATION_MCC_CREATE",
  PARAMETERIZATION_MCC_DELETE = "PARAMETERIZATION_MCC_DELETE",
}

export type IHandleAuth = {
  token: string;
  user: {
    id_user: string;
    email: string;
    name: string;
  };
  profiles?: {
    name: string;
    id_profile: number;
  }[];
  logged_as: EnumAuthContext;
  permissions?: {
    id_permission_profile: number;
    name: string;
    permission_correlation: EnumProfileNameCorrelationPermissions;
  }[];
  products?: {
    active_collection: boolean;
  };
};

interface SignInRequest {
  usuario: {
    nome: string;
    email: string;
    id_usuario: string;
    id_estado?: EnumEstado | number;
    id_estabelecimento?: string;
    id_estabelecimento_whitelabel?: string;
  };
  perfis?: {
    nome: string;
    id_perfil: number;
  }[];
  responsabilidades?: {
    nome: string;
    id_perfil: number;
  }[];
  authenticated: boolean;
  documento_conta?: IDocumentoConta;
  token: string;
  tipo: TipoAcesso;
  permissoes?: { id_permissao_perfil: number, nome: string, permissao_correlacao: string }[];
  tipo_liquidacao?: ITipoLiquidacao[];
}

export function signIn(data: SignInRequest) {
  return {
    type: EnumAuthActions.SIGN_IN,
    payload: data,
  };
}

export function signOut() {
  return {
    type: EnumAuthActions.SIGN_OUT,
    payload: {},
  };
}

export function updateResponsabilidade(responsabilidade: EnumResponsibility) {
  return {
    type: EnumAuthActions.UPDATE_RESPONSABILIDADE,
    payload: { responsabilidade },
  };
}

export function updateShowCurrencyValues(value: boolean) {
  return {
    type: EnumAuthActions.UPDATE_SHOW_CURRENCY_VALUE,
    payload: { show_currency_values: value },
  };
}

export function toggleMenu(value?: boolean) {
  return {
    type: EnumAuthActions.TOGGLE_MENU,
    payload: { toggle_menu: value },
  };
}
